import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/all-employee`;

export const getEmployeesForTable = async (query: any) => {
  const res = await api.get(apiEndPoint, {
    params: query,
  });
  return res;
};
